var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 1.09521H2.66667C1.4025 1.09521 0.375 2.12271 0.375 3.38688V15.0535C0.375 16.3177 1.4025 17.3452 2.66667 17.3452H9.33333C10.5975 17.3452 11.625 16.3177 11.625 15.0535V3.38688C11.625 2.12271 10.5975 1.09521 9.33333 1.09521ZM10.375 15.0535C10.375 15.6277 9.9075 16.0952 9.33333 16.0952H2.66667C2.0925 16.0952 1.625 15.6277 1.625 15.0535V3.38688C1.625 2.81271 2.0925 2.34521 2.66667 2.34521H9.33333C9.9075 2.34521 10.375 2.81271 10.375 3.38688V15.0535ZM7.45833 4.22021C7.45833 4.56521 7.17833 4.84521 6.83333 4.84521H5.16667C4.82167 4.84521 4.54167 4.56521 4.54167 4.22021C4.54167 3.87521 4.82167 3.59521 5.16667 3.59521H6.83333C7.17833 3.59521 7.45833 3.87521 7.45833 4.22021Z",
    fill: "#050B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.682a5cef3e29fd6f14f2512e1793b7da.svg";
export { ForwardRef as ReactComponent };